/**
 * Validates that a string is a well-formed HTTP/HTTPS URL.
 * Accepts: http(s)://domain.tld, localhost, or IPv4 addresses, with optional port and path.
 */
export const isValidUrl = (url: string): boolean =>
  /^https?:\/\/(([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}|localhost|(\d{1,3}\.){3}\d{1,3})(:\d{1,5})?(\/[^\s]*)?$/.test(
    url,
  );

/**
 * Validates provider name, profile name, and partner ID.
 * Allows alphanumeric characters, hyphens (-) and underscores (_).
 * Must be at least 1 character and no spaces.
 */
export const isValidProviderField = (value: string): true | string => {
  if (!value) return true; // let required rule handle empty
  if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
    return 'Only letters, numbers, - and _ are allowed';
  }
  return true;
};
